import React from 'react';
import Logo from '../imagens/dona-mariquinha.jpeg'
import {withRouter} from 'react-router-dom';
import { Link } from 'react-router-dom';
import SemiFooter from './semiFooter';

export default class Footer extends React.Component{
    render(){
        return(
            <div>
                <SemiFooter/>
            <div className="container-fluid footer">
                <div className="container">
                    <section style={{height:80}}></section>
                    <div className="row" style={{textAlign:'center'}}>
                    </div>
                    <footer className="footer-bs">
                <div className="row">
                    <div className="col-md-3 footer-brand animated fadeInLeft">
                        <img src={Logo} width="150px" alt=""/>
                        {/* <p style={{marginTop:20}}>Suspendisse hendrerit tellus laoreet luctus pharetra.</p> */}
                    </div>
                    <div className="col-md-4 footer-nav animated fadeInUp">
                        <h4>Menu —</h4>
                        <div className="col-md-6">
                            <ul className="pages">
                                <li><Link to="/empresa" style={{padding:0}} className="nav-link">Empresa</Link></li>
                                <li><a href="/#produtos">Produtos</a></li>
                                <li><Link to="/receitas" style={{padding:0}} className="nav-link">Receitas</Link></li>
                                <li><a href="/#contato">Fale conosco</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-2 footer-social animated fadeInDown">
                        <h4>REDES SOCIAIS</h4>
                        <ul>
                            <li><a href="https://www.facebook.com/Distribuidora-Dona-Mariquinha-100742948089130">Facebook</a></li>
                            {/* <li><a href="#">Twitter</a></li> */}
                            <li><a href="https://www.instagram.com/produtos_dona_mariquinha/">Instagram</a></li>
                            {/* <li><a href="#">RSS</a></li> */}
                        </ul>
                    </div>
                    {/* <div className="col-md-3 footer-ns animated fadeInRight">
                        <h4>ENTRE EM CONTATO</h4>
                        <p>A rover wearing a fuzzy suit doesn’t alarm the real penguins</p>
                        <p>
                            <div className="input-group">
                            <span className="input-group-btn">
                                <button className="btn btn-default" type="button"><span className="glyphicon glyphicon-envelope"></span></button>
                            </span>
                            </div>
                        </p>
                    </div> */}
                </div>
            </footer>
            <section style={{textAlign:'center'}}><img src="http://divweb.com.br/img/logodivbranca.png" width="45px"></img></section>
    </div>
    </div>
    </div>
        )
    }
}